import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const TagsSection = () => {
  const {
    loading: tagsLoading,
    error: tagsError,
    response: tagsResponse
  } = useFetchGetV2("tags?ordering=id");
  const tableLoadCount = useLoadCounter(tagsLoading);

  if (tagsLoading) {
    return <></>;
  }

  if (tagsError) {
    return <></>;
  }

  if (tagsResponse) {
    return (
      <>
        <SettingsSection title="Tags">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={tagsLoading}
                data-qa_load_count={tableLoadCount}
              >
                {tagsResponse &&
                  tagsResponse?.results.map(tag => (
                    <TableRow key={tag.id}>
                      <TableCell data-col={1}>{tag.id}</TableCell>
                      <TableCell data-col={2}>
                        <Link to={`/pages/settings/tag/${tag.id}`}>
                          {`${tag.name}`}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
